<script lang="ts">
import moment from "moment";

export default {
  name: "MaterialListSheet",
  props: ['material'],
  data: () => ({
    baseUrl: process.env.VUE_APP_API_BASE_URL,
  }),
  computed: {
    hashTags() {
      const tags = [];

      tags.push(...this.material.Themas.map((item) => `#${item.Name.toLowerCase().replaceAll(" ", "")}`));
      tags.push(...this.material.Schulfaecher.map((item) => `#${item.Name.toLowerCase().replaceAll(" ", "")}`));
      tags.push(...this.material.Jahrgangsstufen.map((item) => `#${item.Bezeichnung.toLowerCase().replaceAll(" ", "")}`));
      return tags.join(' ');
    },
    previewUrl() {
      if(!this.material.Vorschau) return undefined;
      return this.baseUrl + this.material.Vorschau.url;
    },
    headerUrl() {
      if(!this.material.Header) return undefined;
      return this.baseUrl + this.material.Header.url;
    },
    showMobileCard() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    date() {
      if(!this.material || !this.material.Datum) return undefined;

      return moment(this.material.Datum).format('DD.MM.YYYY HH:mm');
    }
  }
}
</script>

<template>
  <router-link :to="`/bildungsmaterial/${material.id}`" class="material-link">
    <v-sheet class="mb-2" elevation="1" style="border-radius: 5px">
      <div class="seat-notification" v-if="material.Seats && material.Seats > 0">Begrenzter Inhalt! - Noch {{ material.Seats}} verfügbar!</div>
      <div :class="showMobileCard ? 'material-preview-mobile' : 'material-preview'">
        <img :src="previewUrl" v-if="previewUrl && !showMobileCard" />
        <img :src="headerUrl" v-else-if="headerUrl && showMobileCard" />
        <div v-else style="width: 140px"></div>
        <div class="pa-2" style="display: flex; flex-direction: column; justify-content: space-between">
          <div>
            <v-chip v-if="!material.published_at" x-small label color="warning" class="material-typ-badge mr-2">ENTWURF</v-chip>
            <v-chip color="grey lighten-1" v-if="date" x-small label class="material-typ-badge mr-2">{{ date }}</v-chip>
            <v-chip color="grey lighten-1" x-small label class="material-typ-badge mr-2" v-for="thema of material.Themas" :key="thema.Name">{{ thema.Name }}</v-chip>
            <div class="preview-title primary-text two-line-clamp">{{ material.Titel }}</div>
            <p class="preview-subtitle mb-0 three-line-clamp">{{ material.Subtitel }}</p>
          </div>
          <div class="primary-text preview-hashtags two-line-clamp">{{ hashTags }}</div>
        </div>
      </div>
    </v-sheet>
  </router-link>
</template>

<style scoped>
.preview-title {
  font-size: 24px;
}

.preview-subtitle {
  font-size: 16px;
}

.preview-hashtags {
  font-size: 14px;
}

.material-preview {
  height: 210px;
  display: flex; flex-direction: row;
}

.material-preview-mobile {
  display: flex; flex-direction: column;
}

.material-link:hover {
  text-decoration: none !important;
}

.material-preview-mobile > img {
  object-fit: cover;
  height: 232px;
}
.material-preview > img {
  object-fit: cover;
  width: 140px;
  border-radius: 5px 0 0 5px;
}

.seat-notification {
  width: 100%;
  text-align: center;
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 12px;
  background: #B40055;
  border-radius: 5px 5px 0 0;
  color: white;
  font-weight: 700;
}

.two-line-clamp {
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
}

.three-line-clamp {
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  overflow: hidden;
}
</style>
